<template>
  <div class="main">
    <div class="list-bg">
     <img class="exploreTeam-back" :src="bkimg" alt="">
    </div>
    <div class="contain">
      <div class="contain-title"><img src="../assets/about-title1.png" alt=""></div>
      <div class="contain-tab">
        <img class="contain-tab-img"  :src="base.cImg"/>
        <div class="contain-tab-word">{{base.cImgContent}}</div>
      </div>
      <div class="contain-title"><img src="../assets/about-title2.png" alt=""></div>
      <div class="contain-swiper">
        <swiper :options="swiperOption">
          <swiper-slide v-for='(item, index) of member' :key="index" :style="{backgroundImage:'url('+item.headImg+')'}">
            <div class="swiper-content">
                <div class="swiper-goto-button" @click='goto(item)'>
                    <p>{{item.persionName}}</p>
                    <p>{{item.persionPosition}}</p>
                </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="contain-title"><img src="../assets/about-title3.png" alt=""></div>
      <div class="contain-company">
        <div id="viewer" @click='vclick(e)'>
        </div>
        <!-- <iframe id="viewer" src="https://720yun.com/t/e6vkiqdyOd7?scene_id=35860539" frameborder="0"></iframe> -->
      </div>
      <div class="contain-title"><img src="../assets/about-title4.png" alt=""></div>
      <div class="contain-resume">
        <div class="contain-resume-line"></div>
        <div v-for='(item, index) of honor' :key="index">
          <div class="resume-list" v-if="(index+1) % 2!=0">
            <div class="resume-list-date">{{item.addTime}}</div>
            <div class="resume-list-content">
              <img class="list-content-img" v-if="item.faceImg" :src="item.faceImg" alt="">
              <div class="list-content-title">{{item.title}}</div>
              <div class="list-content-content">{{item.content}}</div>
            </div>
          </div>
          <div class="reresume-list" v-else>
            <div class="reresume-list-date" >{{item.addTime}}</div>
            <div class="reresume-list-content">
              <img class="list-content-img" v-if="item.faceImg" :src="item.faceImg" alt="">
              <div class="list-content-title">{{item.title}}</div>
              <div class="list-content-content">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Banner2 from '../views/Index/banner2'
import {getCompanyBase, getCompanyEnv, getCompanyHonor, getCompanyMember} from '@/api/about.js'
// import {getthemelist} from '@/api/theme.js'import PhotoSphereViewer from 'photo-sphere-viewer'
import PhotoSphereViewer from 'photo-sphere-viewer'
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
import bkimg from '../assets/about-back.png'
export default {
  data () {
    return {
      base: {},
      member: [],
      honor: [],
      Env: [],
      querylist: {
        page: 1,
        limit: 15
      },
      total: undefined,
      bkimg: bkimg,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperList: [{'img': 'https://tripolers.com.cn/admin/storage/fetch/etdt5vljp6wc2upsxrxc.jpg'}, {'img': 'https://tripolers.com.cn/admin/storage/fetch/oujhr4165jzwqtws51ns.jpg'}, {'img': 'https://tripolers.com.cn/admin/storage/fetch/lqvl034xr7tp61qelnh8.jpg'}, {'img': 'https://tripolers.com.cn/admin/storage/fetch/rnhh8ozjt2i6uuabifx7.jpg'}],
      factoryLink: require('@/static/360.jpg'),
      markersData: [
        {
          id: 'image',
          image: require('@/static/images/avart.jpg'),
          width: 35,
          height: 35,
          longitude: 100,
          latitude: 0,
          anchor: 'bottom center',
          tooltip: '雕像',
          selectMarker: function () {
            alert('heill')
          }
        },
        {
          id: 'image2',
          image: require('@/static/images/avart.jpg'),
          width: 35,
          height: 35,
          longitude: 20,
          latitude: -0.15,
          anchor: 'bottom center',
          tooltip: '灯'
        }
      ]
    }
  },
  components: {
    Banner2
  },
  methods: {
    initPhotoSphere () {
      this.PSV = PhotoSphereViewer({
        container: document.getElementById('viewer'),
        panorama: this.factoryLink,
        size: {
          width: '100%',
          height: screen.availHeight
        },
        // caption: '厂区鸟瞰图',
        caption: '  ',
        time_anim: false,
        default_long: 1.4441088145446443,
        default_lat: 0.0800613513013615,
        sphere_correction: {pan: 30.01, tilt: 0, roll: 0},
        // max_fov: 100,         // 最大缩放值
        // min_fov: 99,          // 最小缩放值
        default_fov: 100, // 默认缩放值，在1-179之间
        // latitude_range: [0,0],//禁止上下滑动
        // mousewheel: false,    // 禁止鼠标滚轮缩放
        // navbar: false,
        navbar: [
          'autorotate',
          'zoom',
          'markers',
          'caption',
          'fullscreen'
        ],
        theta_offset: 1000, // 旋转速度
        markers: this.markersData
      }).on
    },
    vclick () {
      // this.PSV.on('click', function (e) {
      //   debugger
      // })
      // this.PSV.on('select-marker', function (marker) {
      //   debugger
      //   if (marker.tooltip.content === '灯') {
      //     this.factoryLink = require('@/static/timg .jpg')
      //     this.PSV.destroy()
      //     this.$nextTick(() => {
      //       this.initPhotoSphere()
      //     })
      //   }
      // if (marker.data && marker.data.generated) {
      //   this.PSV.removeMarker(marker)
      // }
      // })
    },
    // 点击加载更多
    more () {
      this.querylist.page += 1
      this.getlist()
    },
    // 跳转详情页
    gotodetal (id, img, title) {
      this.$router.push({
        name: 'PastReviewDetail',
        params: {
          id: id,
          img: img,
          title: title
        }
      })
    },
    getCompanyBase () {
      getCompanyBase(this.querylist).then(res => {
        this.base = res.data.data
        this.total = res.data.data.total
      })
    },
    getCompanyEnv () {
      getCompanyEnv(this.querylist).then(res => {
        this.Env = res.data.data.items
      })
    },
    getCompanyHonor () {
      getCompanyHonor(this.querylist).then(res => {
        this.honor = res.data.data.items
        this.total = res.data.data.total
      })
    },
    getCompanyMember () {
      getCompanyMember(this.querylist).then(res => {
        this.member = res.data.data.items
      })
    }

  },
  mounted () {
    this.lists = []
  },
  created () {
    this.getCompanyBase()
    this.getCompanyEnv()
    this.getCompanyHonor()
    this.getCompanyMember()
    if (this.$route.query.img) {
      this.bkimg = this.$route.query.img
    }
    this.$nextTick(() => {
      this.initPhotoSphere()
    })
    this.vclick()
  },
  watch: {

  }
}
</script>
<style scoped>
.main{
      background-color:#f4f4f4;
      padding-bottom:1.5rem;
  }
  .list-bg {
        width: 100%;
        height: 672px;
        /* background: url(../assets/about-back.png) no-repeat center; */
        background-size: cover;
    }
  .list-bg img{
    width:100%;
    height: 672px;

  }
  .contain{
    width:80rem;
    background-color: #fff;
    padding-bottom:3.75rem;
    padding-top:59px;
    margin: -200px auto 0;
    position: relative;
  }
  .contain-title{
    width:1032px;
    margin:0 auto;
    margin-bottom:40px;
  }
  .contain-tab{
    display: flex;
    /* justify-content: space-between; */
    padding:0 24px;
    box-sizing: border-box;
    margin-bottom:59px;
  }
  .contain-tab-img{
    width:604px;
    height:356px;
    margin-right:24px;
  }
  .contain-tab-word{
    width:575px;
    height:356px;
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(67,74,81,1);
    overflow: auto;
  }
  ::-webkit-scrollbar{
    width:6px;
    background:rgba(244,244,244,1);
    border-radius:3px;
  }
  /*滚动条中间滑动部分*/
  ::-webkit-scrollbar-thumb {
      background:rgba(182,182,182,1);
      border-radius: 3px;
  }
  .contain-swiper{
    padding:0 24px;
    height:360px;
    margin-bottom:59px;
  }
   .swiper-container {
      height: 100%;
   }
   .swiper-slide{
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .swiper-content {
    width: 100%;
    height: 100%;
    position: relative;
    }
    .swiper-goto-button{
      position: absolute;
      bottom:0;
      left:0;
      height:63px;
      width:100%;
      background-color:rgba(0,0,0,0.5);
      font-size:16px;
      font-family:Source Han Sans CN;
      font-weight:300;
      color:rgba(224,224,224,1);
      text-align: center;
      padding-top:12px;
      box-sizing: border-box;
    }
    .contain-company{
      padding:0 24px;
      box-sizing: border-box;
      width:100%;
      height:549px;
      margin-bottom:79px;
    }
    .contain-resume{
      width:822px;
      height:auto;
      margin:0 auto;
      /* border:1px solid red; */
      position: relative;
      /* display:flex; */
      justify-content: space-between;
      align-content: flex-start;
      flex-flow: wrap;
      /* clear:both; */
      overflow:hidden;
    }
    .contain-resume-line{
      width:1px;
      height:100%;
      border-left:2px dashed rgba(244,244,244,1);
      position: absolute;
      left:50%;
    }
    .resume-list{
      margin-bottom:33px;
      float:left;
    }
    .reresume-list{
      margin-top:40px;
      float:right
    }
    .resume-list-date{
      width:393px;
      height:53px;
      line-height:53px;
      background: url('../assets/about-inleft.png') no-repeat;
      background-size:cover;
      position: relative;
      text-align: right;
      padding-right:39px;
      box-sizing: border-box;
      font-size:14px;
      font-family:Source Han Sans CN;
      font-weight:300;
      color:rgba(83,90,98,1);
    }
    .resume-list-date:after{
      display:block;
      content:'';
      width:10px;
      height:10px;
      background:rgba(0,128,204,1);
      border-radius:50%;
      position: absolute;
      right: -24px;
      top: 22px;
      /* z-index:9999; */
    }
    .resume-list-content{
      width:382px;
      /* height:100px; */
      border:1px solid #f2f2f2;
      border-top:none;
      padding:19px 21px;
      box-sizing: border-box;
    }
    .reresume-list-content{
      width:381px;
      /* height:100px; */
      border:1px solid #f2f2f2;
      border-top:none;
      padding:19px 21px;
      box-sizing: border-box;
      margin-left:12px;
    }
    .list-content-img{
      width:100%;
      height:177px;
      margin-bottom:19px;
    }
    .list-content-title{
      font-size:18px;
      font-family:Source Han Sans CN;
      font-weight:400;
      color:rgba(17,17,17,1);
      margin-bottom:17px;
    }
    .list-content-content{
      font-size:14px;
      font-family:Source Han Sans CN;
      font-weight:300;
      color:rgba(67,74,81,1);
    }

    .reresume-list-date{
      width:393px;
      height:53px;
      line-height:53px;
      background: url('../assets/about-inright.png') no-repeat;
      background-size:cover;
      position: relative;
      text-align: left;
      padding-left:39px;
      box-sizing: border-box;
      font-size:14px;
      font-family:Source Han Sans CN;
      font-weight:300;
      color:rgba(83,90,98,1);
    }
    .reresume-list-date:after{
      display:block;
      content:'';
      width:10px;
      height:10px;
      background:rgba(0,128,204,1);
      border-radius:50%;
      position: absolute;
      left: -22px;
      top: 22px;
      /* z-index:9999; */
    }
    #viewer{
      width:100%;
      height:100% !important;
    }
    .jt{
      position: absolute;
      left:20px;
      top:50%;
      width:100px;
      height:100px;
      background-color: red;
    }
</style>



// WEBPACK FOOTER //
// src/views/about.vue